import React from 'react';
import colors from '../../../styles/colors/index.module.scss';

interface Props {
  width?: number | string;
  color?: string;
  className?: string;
}

export const EpcTag: React.FC<Props> = ({
  width = 100,
  color = colors.primary,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29 17"
    width={width}
    height={typeof width === 'number' ? width * (17 / 29) : 'auto'}
    className={className}
  >
    <path
      d="M2.11744 11.8864C0.355582 9.97255 0.355584 7.02745 2.11744 5.11358L4.87915 2.11358C5.82589 1.08515 7.15991 0.500001 8.55776 0.500001L24 0.5C26.7614 0.5 29 2.73858 29 5.5L29 8.49991L29 11.5C29 14.2614 26.7614 16.5 24 16.5L8.55776 16.5C7.15991 16.5 5.82589 15.9148 4.87915 14.8864L2.11744 11.8864Z"
      fill={color}
    />
  </svg>
);
